module.exports = __webpack_public_path__ + "004e1934.png";